import React from "react";
import { oneOf, bool, string } from "prop-types";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";
import fontWeight from "../utils/fontWeight";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { colorPropTypes, fontSizePropTypes, sxClassName, sxProps, sxPropTypes } from "../props/sx";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const Paragraph = ({
	Tag = "p",
	size,
	center,
	uppercase = false,
	color,
	className = "",
	block = false,
	weight,
	italic,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	sx = { ...sxProps },
	...props
}) => {
	const fontSizeProp = size ? { fontSize: size } : {};
	const fontWeightProp = weight ? { fontWeight: weight } : {};
	const fontColorProp = color ? { fontColor: color } : {};
	const fontStyleProp = italic ? { fontStyle: "italic" } : {};
	const textAlignProp = center ? { textAlign: "center" } : {};
	const textTransformProp = uppercase ? { textTransform: "uppercase" } : {};
	const displayProp = block ? { display: "block" } : {};
	return (
		<Tag
			className={classes(
				...utilityClassName(deepMergeProps({ ...displayProp }, pureProps(utility))),
				...sxClassName(
					deepMergeProps(
						{
							...fontWeightProp,
							...fontSizeProp,
							...fontColorProp,
							...fontStyleProp,
							...textAlignProp,
							...textTransformProp,
						},
						pureProps(sx),
					),
				),
				...spacingClassName(spacing),
				className, // specific classes
			)}
			{...props}
		/>
	);
};

Paragraph.propTypes = {
	Tag: string,
	size: fontSizePropTypes,
	italic: bool,
	center: bool,
	block: bool,
	uppercase: bool,
	weight: oneOf(Object.keys(fontWeight)),
	color: colorPropTypes,
	spacing: spacingPropTypes,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	className: string,
};

export default pureFC(Paragraph);
